import axiosInstance from './axiosInstance';

export const getAllRoleRights = () =>
    axiosInstance.get("/RoleRight/GetAllRoleRights");

export const updateRoleRight = (request) =>
    axiosInstance.put("/RoleRight/UpdateRoleRight", request);

export const getAllRoles = () =>
    axiosInstance.get("/RoleRight/GetAllRoles");

export const getAllRights = () =>
    axiosInstance.get("/RoleRight/GetAllRights");

export const getUserRights = (userId) =>
    axiosInstance.get(`/RoleRight/GetUserRights?userId=${userId}`);

export const updateUserRight = (request) =>
    axiosInstance.put("/RoleRight/UpdateUserRight", request);

// Everyone carrying a per-user override, so the exceptions can be listed rather
// than hunted for one agent at a time. (user 2026-09-27)
export const getUsersWithOverrides = () =>
    axiosInstance.get("/RoleRight/GetUsersWithOverrides");
